







































import {Component} from "vue-property-decorator"
import Vue from "vue"
import tinycolor from "tinycolor2"

import JdiContent from "@/components/JdiContent.vue"
// @ts-ignore
import * as tw from "../../../tailwind.config.js"
import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"

@Component({
    components: {JdiStatus, JdiHeading, JdiContent}
})
export default class Color extends Vue {

    get utilColors() {
        return Object.keys(tw.theme.colors).filter(key => {
            return typeof tw.theme.colors[key] !== 'object';
        }).reduce((obj: {[key: string]: any}, key) => {
            obj[key] = tw.theme.colors[key];
            return obj;
        }, {});
    }

    get colors() {
        return Object.keys(tw.theme.colors).filter(key => {
            return typeof tw.theme.colors[key] === 'object';
        }).reduce((obj: {[key: string]: any}, key) => {
            obj[key] = tw.theme.colors[key];
            return obj;
        }, {});
    }

    luminance(color: string) {
        return tinycolor(color).getLuminance().toPrecision(3);
    }
}
